import { EditPageItemNameEditorState } from '../../typings/editPageItemNameEditor';

export const getDefaultEditPageItemNameEditorState = (isNew?: boolean): EditPageItemNameEditorState => {
    return {
        value: '',
        isVisible: isNew ? true : false
    };
};
